export default __webpack_public_path__ + "static/media/winner_10.25ac735a.jpg";